import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import leads from './leadsPage/handler';
import lead from './leadPage/handler';

export default pipeHandlers(common, leads, lead);
